import EA from '../helpers/init';

export default EA.Methods.calcPagination = ($this) => {
    const pageBtns = $this.querySelectorAll('.press-page-number');
    const controlBtns = $this.querySelectorAll('.press-list-button');
    let currentActive = null;
    
    pageBtns.forEach((btn, index) => {
        if (btn.classList.contains('active')) {
            currentActive = index;
            return;
        }
    });

    console.log(currentActive);
    

    if (currentActive === 0) {
        controlBtns[0].classList.add('disabled');
    } else if (currentActive === (pageBtns.length - 1)) {
        controlBtns[1].classList.add('disabled');
    }

    if (pageBtns.length > 3) {
        if (currentActive === 0 || currentActive === 1) {
            pageBtns.forEach((element, index) => {
                if (index !== 0 && index !== 1 && index !== ( pageBtns.length - 1)) {
                    element.classList.add('hidden');
                }
            });
    
            const p = document.createElement('p');
            p.textContent = '...';
            p.style.userSelect = 'none';
            pageBtns[pageBtns.length - 1].before(p);
        } else if (currentActive === pageBtns.length - 1 || currentActive === pageBtns.length - 2) {
            pageBtns.forEach((element, index) => {
                if (index !== pageBtns.length - 1 && index !== pageBtns.length - 2 && index !== 0) {
                    element.classList.add('hidden');
                }
            });
    
            const p = document.createElement('p');
            p.textContent = '...';
            p.style.userSelect = 'none';
            pageBtns[0].after(p);
        } else if(currentActive === pageBtns.length - 3) {
            pageBtns.forEach((element, index) => {
                if (index !== pageBtns.length - 1 && index !== pageBtns.length - 2 && index !== pageBtns.length - 3 && index !== 0) {
                    element.classList.add('hidden');
                }
            });
    
            const p = document.createElement('p');
            p.textContent = '...';
            p.style.userSelect = 'none';
            pageBtns[0].after(p);
        } else {
            pageBtns.forEach((element, index) => {
                if (index !== pageBtns.length - 1 && index !== currentActive && index !== 0) {
                    element.classList.add('hidden');
                }
            });
    
            const p1 = document.createElement('p');
            const p2 = document.createElement('p');
            p1.style.userSelect = 'none';
            p2.style.userSelect = 'none';
            p1.textContent = '...';
            p2.textContent = '...';
            pageBtns[0].after(p1);
            pageBtns[pageBtns.length - 1].before(p2);
        }
    }
};
